// eslint-disable-next-line no-unused-vars
import React from "react";
import Select from 'react-select';
import './style.css';

let remove_Cat = [];
let add_Cat = [];
class MultiSelect extends React.Component {
    state = {
      selectedOptions: this.props.Category_keys,
      selectedValues: this.props.selectedCategories,
    };
    
    
    handleChangeCategory = (arr) => {
        if (!arr) {
            arr = [];
        }
        //let arr_unique = [...new Map(arr.map(item => [item['label'], item])).values()];
        remove_Cat.length = 0;
        remove_Cat = this.state.selectedValues.filter(x => !arr.includes(x));
        add_Cat.length = 0;
        add_Cat = arr.filter(x => !this.state.selectedValues.includes(x));
        this.setState({selectedValues:arr});
        /*
        store_Cat.length = 0;
        
        this.props.Categories.forEach(function (element,index) {
            arr.forEach(function (cat_Name) {
                if (element.entity_name === cat_Name.label) {
                    store_Cat.push({ value: index, label: element.entity_name, entity_uuid: element.entity_uuid, entity_name: element.entity_name });
                    //store_Cat.push(element)
                } else {
                    //remove_Cat.push({ value: index, label: element.entity_name, entity_uuid: element.entity_uuid, entity_name: element.entity_name });
                }
            })
        })
       
        //this.pushToParent(store_Cat,remove_Cat);
        */
        this.props.multiSearchSelectData(add_Cat,remove_Cat,arr);
    }
    /*
    // Function to send selected data to parent component
    pushToParent = data => {
        this.props.multiSearchSelectData(data);
    }
    */

    render() {
      // eslint-disable-next-line no-unused-vars
      const { Category_keys,selectedCategories} = this.props;
      
      const customStyles = {
        control: (base, state) => ({
          ...base,
          backgroundColor: this.props.theme === "dark" ? "#333333" : "#ffffff",
          color: this.props.theme === "dark" ? "#eeeeee" : "#222222",
          // match with the menu
          //borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
          // Overwrittes the different states of border
          //borderColor: state.isFocused ? "yellow" : "green",
          // Removes weird border around container
          //boxShadow: state.isFocused ? null : null,
          //"&:hover": {
            // Overwrittes the different states of border
            //borderColor: state.isFocused ? "red" : "blue"
          //}
        }),
        menu: base => ({
          ...base,
          backgroundColor: this.props.theme === "dark" ? "#333333" : "#ffffff",
          color: this.props.theme === "dark" ? "#eeeeee" : "#222222",
          // override border radius to match the box
          //borderRadius: 0,
          // kill the gap
          //marginTop: 0
        }),
        menuList: base => ({
          ...base,
          backgroundColor: this.props.theme === "dark" ? "#333333" : "#ffffff",
          color: this.props.theme === "dark" ? "#eeeeee" : "#222222",
          // kill the white space on first and last option
          //padding: 0
        })
      };
      
      
      return (
          <div className="multiSelect" style={{ color: "black" }}>
            <Select
            closeMenuOnSelect={false}
            //defaultValue={receivedProps ? apiCategories : selected}
            //defaultValue={selected}
            //value={selectedValues.length > 0 ? selectedValues : selected}
            value={this.state.selectedValues}
            onChange={this.handleChangeCategory}
            options={Category_keys}
            isMulti={true}
            //styles={customStyles}
            />
        </div>
      );
    }
  }

  export default MultiSelect;